import { useRef } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { useDidUpdate } from "app/custom-hooks/useDidUpdate";

import { StyledParenthesisedContent } from "../../../styles";

type SelectedColumnsListHeadingProps = {
    columnsCount: number;
};

export const SelectedColumnsListHeading = ({ columnsCount }: SelectedColumnsListHeadingProps) => {
    const { translate } = useTranslate();

    const counterRef = useRef<HTMLElement>(null);

    useDidUpdate(() => {
        counterRef.current?.animate(
            { fontWeight: [400, 900, 900, 400], offset: [0, 0.2, 0.8], easing: "ease-in-out" },
            1000,
        );
    }, [columnsCount]);

    return (
        <Text
            fontVariant="h5_2"
            color={colorsPalettes.carbon[400]}
        >
            {translate("si.components.advanced_search_results_table.column_picker.added_columns_list.title")}

            <StyledParenthesisedContent ref={counterRef}>{columnsCount}</StyledParenthesisedContent>
        </Text>
    );
};
